export default {
  FEATURES: 1,
  INSTANCES: 2,
  PROJECTS: 3,
  SPACES: 4,
  DASHBOARD: 5,
  ROLES: 6,
  PROJECT_REPORTS: 7,
  USERS: 8,
  REPORTS: 9,
  PROJECT_PAYMENTS: 10,
  PROFILE: 11,
  CALENDAR: 12,
  CALENDAR_SELECT: 13,
  TIMES: 14,
  TIMES_APPROVE_BUTTON: 15,
  PROJECTS_EDIT: 16,
  TIMES_EDIT_BUTTON: 17,
  TIMES_DELETE_BUTTON: 18,
  PROJECT_TIMES_BLOCK: 19
}
